/* eslint-disable no-nested-ternary */
import { Article } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import { insertAdvertInArray } from '@adverts/business/adverts.utils';
import { PlcApiResponseInterface } from '@api/business/api.hook';
import { PlcMessageWithRetry } from '@components/PlcMessage/PlcMessageWithRetry.component';
import { Text } from '@components/Text/Text.component';
import { ContentCardLoaderHomeVersion } from '@content/ContentCardHomeVersion/ContentCardLoaderHomeVersion.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { buildContentCard } from '@utils/card';
import classnames from 'classnames';

type Props = ComponentPropsWithRef<'div'> & PlcApiResponseInterface<Article[]>;

const ReadAlsoArticle: FC<Props> = ({ data, isValidating, error, retryCallback }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.s);
  const cards = data?.map((item, index) => buildContentCard(item, isMobile, 'home-version', index, data));
  const cardsWithAds = cards
    ? insertAdvertInArray(
        insertAdvertInArray(cards, 2, 4, ADVERT_FORMAT_ID.NativeAd),
        3,
        4,
        ADVERT_FORMAT_ID.NativeAdBis
      )
    : null;

  const listClassName = classnames('flex', 'column');
  return (
    <section className="plc-pb-l">
      <div className="wrapper-s read-also">
        <Text className="plc-mb-m" i18nKey="common.read-also" tag="p" variant="p-h3-upper-style" />
        <div className={listClassName}>
          {isValidating ? (
            <>
              <ContentCardLoaderHomeVersion uniqueKey="readAlsoArticle1" />
              <ContentCardLoaderHomeVersion uniqueKey="readAlsoArticle2" />
            </>
          ) : error ? (
            <PlcMessageWithRetry retryCallback={retryCallback} />
          ) : (
            cardsWithAds
          )}
        </div>
      </div>
    </section>
  );
};

export default ReadAlsoArticle;
